import React from 'react'
import StatusDropdown from '../../components/StatusDropdown';
import SalesStatusCard from './SalesStatusCard';

import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'
import {ReactComponent as SearchIcon} from '../../components/svgs/searchicon.svg';
import {ReactComponent as FilterIcon} from '../../components/svgs/filterIcon.svg';
import {ReactComponent as ExportIcon} from '../../components/svgs/exportIcon.svg';

import { Link } from 'react-router-dom';
import DropdownSVG from '../../components/OrderDropdown';


// laundry status data
const laundryStatus = [
    { label: 'All', link: '#' },
    { label: 'Binned', link: '#' },
    { label: 'Washing', link: '#' },
    { label: 'Drying', link: '#' },
    { label: 'Folding', link: '#' },
  ];

  const options = [
    { label: 'Edit Order', link: '#' },
    { label: 'Duplicate Order', link: '#' },
    { label: 'Print Details', link: '#' },
    { label: 'Archive Orders', link: '#' }
  ];

const SalesByAmountTab = () => {

    const tabs = [
        {
         
          tableData: [
            { customer: 'Geller Industries', commercialCustomerRep: 'Ross Geller', amount: '$40.00', billingType: 'Credit Card', billedFor: 'Order #24', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
            { customer: 'Phoebe Buffay', amount: '$40.00', billingType: 'Cash', billedFor: 'Order #24', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
            { customer: 'Tribianni & Sons Ltd.', commercialCustomerRep: 'Joey Tribianni', amount: '$40.00', billingType: 'Credit Card', billedFor: 'Order #24', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
            { customer: 'Monica’s Inc', commercialCustomerRep: 'Monica’s Geller-Bing', amount: '$40.00', billingType: 'Cash', billedFor: 'Order #24', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
            { customer: 'Chandler Bing', amount: '$40.00', billingType: 'Credit Card', billedFor: 'Order #24', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details'},
            { customer: 'Marcel Geller', amount: '$40.00', billingType: 'Cash', billedFor: 'Order #24', paymentDate: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details'},
          ]
        },
    
         
      ];

  return (
    <>
      
        <section className='mt-10 flex gap-10'>
            <SalesStatusCard statusTitle={'Total sales'} noOfOrdersClassName={'custom-style'} salesRevenue={'$ 14,730.72'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-52" />}/>
            <SalesStatusCard statusTitle={'Revenue realized'} noOfOrdersClassName={'custom-style'} salesRevenue={'$ 14,600.00'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-36" />}/>
            <SalesStatusCard statusTitle={'Outstanding payment'} noOfOrdersClassName={'custom-style'} salesRevenue={'$ 130.72'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-24" />}/>
        </section>
        <section className='flex gap-14 mt-14 mb-5'>
            <div className='left-chart'>
                <div className='flex flex-col gap-4'>
                    <div className='flex gap-28'>
                        <p className='chart-title ml-6'>Sales Distribution</p>
                        <div>
                            <StatusDropdown dropdownText={'All Time'} className="" />
                        </div>
                    </div>
                    
                    <div className='chart-divider mt-4'></div>
                </div>
            </div>
            <div className='right-chart'>
            <div className='flex flex-col'>
                    <div className='flex gap-64'>
                        <p className='chart-title ml-6'>Sales Trend</p>
                        <div className='ml-64 chart-dropdown'>
                            <StatusDropdown dropdownText={'Last 12 months'} className="" />
                        </div>
                    </div>
                    
                    <div className='chart-divider right-chart-divider mt-6'></div>
                </div>
            </div>
        </section>

        <div className="tab-container">
        <section className='flex search-filter-section mt-4 mb-4 ml-4'>
            <section>
                <form action="">
                    <label htmlFor="" className="flex flex-col order-search-input">
                        <SearchIcon className='order-search-icon search-icon'/>
                        <input type="text" placeholder="Search" className="mt-2"/>
                    </label>
                </form>
            </section>
            <section className='flex gap-10 ml-20'>
                <div className='flex gap-4'>
                    <FilterIcon/>
                    <p className='filter-section-text'>Filter</p>

                </div>
                <div className='flex gap-4'>
                    <ExportIcon/>
                    <p className='filter-section-text'>Export as csv</p>
                    
                </div>
            </section>
        </section>    
            

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div key={index} className={``}>
            <table className="custom-table custom-order-table">

              <thead>
                <tr className='table-head'>
                <th>
                    Amount
                    <span className="filter-icon">
                    <ActiveIcon />
                    </span>
                  </th>
                  <th className=''>
                    Customer
                    <span className="filter-icon">
                    <ActiveIcon className=''/>
                    </span>
                  </th>

                  <th>
                  Billed for
                    <span className="filter-icon">
                        <ActiveIcon />
                    </span>
                  </th>
                  
                  <th>
                    Billing type
                    <span className="filter-icon">
                      <ActiveIcon />
                    </span>
                  </th>
                  
                  <th>
                    Payment date
                    <span className="filter-icon">
                        <ActiveIcon />
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody className='table-body'>
                {tab.tableData.map((data, dataIndex) => (
                  <tr key={dataIndex} className='table-row'>
                    <td className='table-data'>
                      {data.amount}
                    
                    </td>
                   
                    <td className='table-data-1'>
                      {data.customer}
                      <div className='customer-rep'>{data.commercialCustomerRep}</div>
                    </td>
                   
                    <td className='table-data'>
                      {data.billedFor}
                   
                    </td>
                    
                    <td className='table-data'>
                      {data.billingType}
                    
                    </td>
                    
                    <td className='table-data'>
                      {data.paymentDate}
                   
                    </td>
                    <td>
                        <Link to={data.viewButton} className='view-btn'>View</Link>
                    </td>
                    <td>
                    <DropdownSVG options={options} className="my-dropdown" />
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default SalesByAmountTab